import React, { Fragment, ReactNode } from "react";
import { NavLink } from "react-router-dom";

type Props = {
  label: string;
  description?: any;
  to?: string;
  icon?: ReactNode;
  bottomBorder?: boolean;
  onClick?: any;
  time?: any;
};

const DropdownItem = (props: Props) => {
  const convertDate = (date) => {
    const newDate = new Date(date);
    return newDate.toLocaleString();
  };

  return (
    <Fragment>
      <NavLink
        to={props.to}
        className={`drop-down-item ${props.bottomBorder && "border-bottom"}`}
        onClick={props.onClick}
      >
        {props.icon && <div className="drop-down-icon">{props.icon}</div>}
        <div className="drop-down-content">
          {props.label && <div className="drop-down-label">{props.label}</div>}
          {props.description && (
            <div className="drop-down-description">
              {props.description.slice(0, 20) + "..."}
            </div>
          )}
          {props.time && (
            <div className="drop-down-time">{convertDate(props.time)}</div>
          )}
        </div>
      </NavLink>
    </Fragment>
  );
};

export default DropdownItem;
